import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const confirmWholesaler = async (data: { code?: string }) =>
  axios.post(Routes.CONFIRM_WHOLESALER, data);

export const useConfirmWholesaler = () =>
  useMutation({
    mutationKey: [Keys.CONFIRM_WHOLESALER_MUT],
    mutationFn: confirmWholesaler,
    cacheTime: 0,
  });
